module.exports = __webpack_public_path__ + "img/course106.a9386566.png";